import { useId } from "react";

interface TriStateToggleProps {
  legend: string;
  helpText?: string;
  value: "yes" | "no" | "unknown" | undefined;
  onChange: (value: "yes" | "no" | "unknown") => void;
}

const OPTIONS: { id: "yes" | "no" | "unknown"; label: string }[] = [
  { id: "yes", label: "Yes" },
  { id: "no", label: "No" },
  { id: "unknown", label: "Not sure" }
];

/** A compact three-way yes/no/not-sure control, used for the work-type flags in "What are you changing?". Native radios under the hood for keyboard + screen-reader support. */
export function TriStateToggle({ legend, helpText, value, onChange }: TriStateToggleProps) {
  const name = useId();
  const helpId = useId();

  return (
    <fieldset className="tri-toggle" aria-describedby={helpText ? helpId : undefined}>
      <legend className="tri-toggle__legend">{legend}</legend>
      <div className="tri-toggle__options">
        {OPTIONS.map((opt) => (
          <label key={opt.id} className={`tri-toggle__option${value === opt.id ? " tri-toggle__option--selected" : ""}`}>
            <input
              type="radio"
              name={name}
              value={opt.id}
              checked={value === opt.id}
              onChange={() => onChange(opt.id)}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
      {helpText ? (
        <p id={helpId} className="tri-toggle__help">
          {helpText}
        </p>
      ) : null}
    </fieldset>
  );
}
